import { DENSITY } from 'src/app/core/enums/operations.enum';
import { OperationsRouteDetail } from 'src/app/core/models/operations/operations-route-details.model';

export const CONST = {
  OPERATIONS: {
    SUBHEADER: $localize`Pickup Assignments`,
    HEADER: $localize`Operations`,
  },
  ADD_ROUTE: $localize`Add Pickup`,
};

export const MOCK_OPERATION_ROUTE_DETAILS: OperationsRouteDetail = {
  id: 1,
  type: 'PS',
  state: 'Pending',
  density: DENSITY.COMMERCIAL,
  planseq: 123,
  cosignee: 'Micheal Scott',
  address: 'Dunder Miflin',
  city: 'Scranton',
  province: 'ON',
  postal: '12345',
  completiontime: '00:00',
  stopDate: new Date('01/01/2022').toString(),
  packagedetails: [
    {
      trackingnumber: '123',
      committime: '01:01',
      eta: 'whatever',
      scancode: 'FS',
      description: 'test',
      amtdue: '12',
      amtcollected: '12',
      shippernumber: '123456',
      paymentType: 'CASH',
      position: 0,
      scancodeDesc: 'true',
    },
  ],
  streetparsed: {
    prefix: '01',
    name: 'Jim',
    suffix: '02',
    type: 'Apartment',
    number: '222',
  },
};

export const MOCK_OPERATION_ROUTE_DETAILS_NO_PACKAGE: OperationsRouteDetail = {
  id: 1,
  type: 'PS',
  state: 'Pending',
  density: DENSITY.COMMERCIAL,
  planseq: 123,
  cosignee: 'Micheal Scott',
  address: 'Dunder Miflin',
  city: 'Scranton',
  postal: '12345',
  province: 'ON',
  completiontime: '00:00',
  stopDate: new Date('01/01/2022').toString(),
  packagedetails: [],
  prn: '1',
  streetparsed: {
    prefix: '01',
    name: 'Jim',
    suffix: '02',
    type: 'Apartment',
    number: '222',
  },
};
